module.exports = __webpack_public_path__ + "static/media/island-tropical.b0fb3e8b.svg";